import { formatDate } from '@utils/date';

function admin(state = { stats: [], plans: [] }, action) {
  switch (action.type) {
    case 'ADMIN_RECEIVE_PLANS':
      return {
        ...state,
        plans: action.plans,
      };
    case 'ADMIN_RECEIVE_STATS':
      return {
        ...state,
        stats: action.stats.map(user => {
          const webLoginDates = user.stats.webLoginDates.map(
            date => new Date(date)
          );
          return {
            ...user,
            created: user.created,
            subs: user.subs,
            stats: {
              ...user.stats,
              web: {
                loginCount: user.stats.webLoginDates.length,
                loginDates: webLoginDates,
                uniqueLogins: new Set(
                  webLoginDates.map(d => formatDate(d, 'l'))
                ),
                lastDate:
                  user.stats.webLoginDates[user.stats.webLoginDates.length - 1],
              },
              launcher: {
                loginCount: user.stats.launcherLoginDates.length,
                loginDates: user.stats.launcherLoginDates.map(
                  date => new Date(date)
                ),
                lastDate:
                  user.stats.launcherLoginDates[
                    user.stats.launcherLoginDates.length - 1
                  ],
              },
            },
          };
        }),
      };
    default:
      return state;
  }
}

export default admin;
